import React from "react";
import useAppContext from "../../../../hooks/useAppContext";
import { wrapperClasses, titleClasses, stackColumnGap10 } from "./style";
import SavedAttachmentItem from "./SavedAttachmentItem";

const SavedAttachments = () => {
  const { savedAttachments, savedAttachmentsComparison } = useAppContext();

  return (
    <div>
      <div className={wrapperClasses}>
        <div className={titleClasses}>Saved</div>
        <div className={stackColumnGap10}>
          {savedAttachments.map((savedAttachment) => {
            return <SavedAttachmentItem savedAttachment={savedAttachment} key={savedAttachment.attachmentId} />;
          })}
          {savedAttachmentsComparison.map((savedAttachment) => {
            return <SavedAttachmentItem savedAttachment={savedAttachment} key={savedAttachment.attachmentId} />;
          })}
        </div>
      </div>
    </div>
  );
};

export default SavedAttachments;
